import React from 'react';
import PropTypes from 'prop-types';

import  Navbar  from './components/Navbar';

const useStyles = {
  root: {
    paddingTop: 64,
    height: '100vh'
  },
  content: {
    height: '100%'
  }
};

const Minimal = props => {
  const { children } = props;



  return (
    <div >
      {/* <Navbar /> */}
      <main style={useStyles.content}>{children}</main>
    </div>
  );
};

Minimal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Minimal;
